import { Component, OnInit, Input } from '@angular/core';
import { DirectionService } from '@app/_services/direction.service';
import { TranslateService } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-block-link',
    templateUrl: './block-link.component.html',
    styleUrls: ['./block-link.component.scss'],
    standalone: true,
    imports: [NgIf, MatIconModule, RouterLink]
})
export class BlockLinkComponent implements OnInit {
    @Input() url: string;
    @Input() title: string;
    @Input() subtitle: string = '';
    @Input() external: boolean = true;

    rtl;
    lang;

    constructor(private direction: DirectionService, private translate: TranslateService,
    ) { }

    ngOnInit(): void {
        this.rtl = this.direction.isRTL()
        this.lang = this.translate.currentLang;
    }
}
